module.exports = __webpack_public_path__ + "static/media/AOB_large.07ec7624.svg";